import React, { useState, useEffect, useCallback } from "react";
import "./SiteWideBannerText.css";

const SiteWideBannerText = ({ texts }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextText = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
  }, [texts.length]);

  // const prevText = () => {
  //   setCurrentIndex(
  //     (prevIndex) =>
  //       (prevIndex - 1 + texts.length) % texts.length
  //   );
  // };

  useEffect(() => {
    const interval = setInterval(nextText, 3000); // Auto-slide every 3 seconds
    return () => clearInterval(interval); // Cleanup on unmount
  }, [nextText]); // Include memoized `nextText` in dependency array

  return (
    <div className="sitewide-banner">
      {/* Left Arrow */}
      {/* <button className="banner-arrow left" onClick={prevText}>
        &#8592;
      </button> */}

      {/* Banner Text */}
      <div className="banner-text">
        <p>{texts[currentIndex]}</p>
      </div>

      {/* Right Arrow */}
      {/* <button className="banner-arrow right" onClick={nextText}>
        &#8594;
      </button> */}
    </div>
  );
};

export default SiteWideBannerText;
